/* unplugin-vue-components disabled */import { render } from "./duplicate.vue?vue&type=template&id=5ad62ed2&scoped=true"
import script from "./duplicate.vue?vue&type=script&lang=js"
export * from "./duplicate.vue?vue&type=script&lang=js"

import "./duplicate.vue?vue&type=style&index=0&id=5ad62ed2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad62ed2"],['__file',"src/pages/share-prompt/duplicate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ad62ed2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ad62ed2', __exports__)) {
    api.reload('5ad62ed2', __exports__)
  }
  
  module.hot.accept("./duplicate.vue?vue&type=template&id=5ad62ed2&scoped=true", () => {
    api.rerender('5ad62ed2', render)
  })

}


export default __exports__